import React from "react";

// 3D rendered icon (PNG with alpha) with floating shadow
export default function Icon3D({ name, size = 64, style, float = false }) {
  return (
    <div className={float ? "float-medium" : ""} style={{ width: size, height: size, position: "relative", display: "inline-block", ...style }}>
      <div style={{ position: "absolute", left: "15%", right: "15%", bottom: -6, height: 10, borderRadius: "50%", background: "radial-gradient(ellipse, rgba(194,65,12,0.35), transparent 70%)", filter: "blur(3px)" }} />
      <img src={`/img/icons/${name}.png`} alt="" style={{ width: "100%", height: "100%", objectFit: "contain", filter: "drop-shadow(0 6px 10px rgba(194,65,12,0.28))", position: "relative" }} draggable={false} />
    </div>
  );
}
